import { LimitingWrapper } from '@gc-bridge/components/Container/LimitingWrapper';
import { AdditionalColors } from '@gc-bridge/theme/colors';
import { Box, styled, Typography } from '@mui/material';
import GcBridgeBackground from '../assets/images/gc-bridge-background.png';

const Container = styled(Box)({
  backgroundImage: `url(${GcBridgeBackground})`,
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '500px',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  width: '100%',
});

export const Triangle = styled(Box)(() => ({
  backgroundColor: AdditionalColors.UltramarineShadow,
  clipPath: 'polygon(100% 90%, 0 100%, 100% 100%)',
  width: '100%',
  height: '100%',
  position: 'absolute',
  bottom: 0,
}));

export const MainHeading = styled(Typography)(({ theme: { palette } }) => ({
  textAlign: 'start',
  color: palette.primary.contrastText,
  fontSize: '100px',
  fontWeight: 700,
  fontStyle: 'bold',
  lineHeight: '105px',
  letterSpacing: '1.06px',
  textTransform: 'none',
}));

export function GcBridgeCover() {
  return (
    <Container>
      <LimitingWrapper>
        <MainHeading>GC Bridge</MainHeading>
        <Typography
          variant="h5"
          textAlign="start"
          color="primary.contrastText"
          fontSize="30px"
          letterSpacing="0.15px"
          maxWidth="60%"
        >
          Manage all of your client and reinsurer engagement, including placements and
          advisory workflows-in one global, digital platform.
        </Typography>
      </LimitingWrapper>
      <Triangle />
    </Container>
  );
}
